import { useState, useEffect } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import type { TBondScreenerFilterBoundaries } from '@/creditflowresearch/domain/vo/Bondscreener';
import BondScreenersRepository from '@/creditflowresearch/infrastructure/repository/BondScreenersRepository';

const useFilterBoundaries = (isOpen: boolean, filterType: 'corp' | 'abs') => {
  const container = getContainer();
  const repository = container.get<BondScreenersRepository>(BondScreenersRepository);

  const [filters, setFilters] = useState<TBondScreenerFilterBoundaries | null>(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const fetchFilters = async (): Promise<void> => {
      if (!filters) {
        setIsFetching(true);
      }
      try {
        const data = await repository.getFilterBoundaries(filterType);
        setFilters(data);
      } catch (error) {
        AlertManager.error('Failed to load filter options');
      } finally {
        setIsFetching(false);
      }
    };

    fetchFilters();
  }, [isOpen, filterType]);

  return { filters, isFetching };
};

export default useFilterBoundaries;
